import { makeMap } from './utils';

export const notEmpty = v => {
  if (v === undefined || v === null) return false;
  if (typeof v === 'number' && isNaN(v)) return false;
  if (Array.isArray(v) && !v.length) return false;
  return !!v;
};

const common = {
  NOT_EMPTY: notEmpty,
  NO_SPACE: /^[^\s]*$/,
  MULTI_SPACE: /(?=\s{2,})/
};

const rules = {
  ...common
};

/**
 * 校验值类型 返回boolean
 * @param {any} target
 * @param {string} type
 * @returns {boolean}
 */
export const expect = (target, type, note) => {
  const res = Object.prototype.toString.call(target).slice(8, -1) === type;
  if (!res) console.error(note);
  return res;
};

/**
 * 根据校验器类型 进行校验
 * @param {Function|RegExp} validator 校验器
 * @param {string} v 待校验字符串
 * @returns {boolean}
 */
const execute = (validator, v) => {
  if (typeof validator === 'function') return validator(v);
  return validator.test(v);
};

/**
 * 校验合法字符
 * @param {string} str 待校验字符串
 * @param {RegExp|keyof common} rule 内部规则名或者正则
 * @returns {boolean}
 */
export const validChar = (str, rule) => {
  let validator = null;
  if (typeof rule === 'object') validator = rule;
  else validator = rules[rule];
  return execute(validator, str);
};

/**
 * 校验参数对象 移除空值
 * @param {{[index:String]:any}} target
 * @param {String} rules default 'String,Number,Array'
 * @param {Boolean} deep 是否深度清除
 * @returns {void}
 */
export const validParamObject = (target, rules, deep) => {
  // 克隆数据
  target = JSON.parse(JSON.stringify(target));
  // 默认校验规则
  rules = rules || 'String,Number,Array';
  const has = makeMap(rules);
  const keys = Object.keys(target);
  // 临时变量 存储遍历值
  let val = null;
  // 是否删除标志
  let del = false;
  keys.forEach(key => {
    del = false;
    val = target[key];
    if (val === null || val === undefined) del = true;
    if (has('Number') && val === 0) del = true;
    if (has('Array') && Array.isArray(val) && !val.length) del = true;
    if (has('String') && val === '') del = true;
    if (deep && typeof val === 'object') validParamObject(val, rules);
    if (del) delete target[key];
  });
  return target;
};
